
      import API from "!../../../eckpunkt-app/node_modules/style-loader/dist/runtime/injectStylesIntoStyleTag.js";
      import domAPI from "!../../../eckpunkt-app/node_modules/style-loader/dist/runtime/styleDomAPI.js";
      import insertFn from "!../../../eckpunkt-app/node_modules/style-loader/dist/runtime/insertBySelector.js";
      import setAttributes from "!../../../eckpunkt-app/node_modules/style-loader/dist/runtime/setAttributesWithoutAttributes.js";
      import insertStyleElement from "!../../../eckpunkt-app/node_modules/style-loader/dist/runtime/insertStyleElement.js";
      import styleTagTransformFn from "!../../../eckpunkt-app/node_modules/style-loader/dist/runtime/styleTagTransform.js";
      import content, * as namedExport from "!!../../../eckpunkt-app/node_modules/css-loader/dist/cjs.js!../../../eckpunkt-app/node_modules/vue-loader/dist/stylePostLoader.js!../../../eckpunkt-app/node_modules/postcss-loader/dist/cjs.js!../../../eckpunkt-app/node_modules/vue-loader/dist/index.js??ruleSet[1].rules[9].use[0]!./ProductDetailsPage.vue?vue&type=style&index=0&id=080082d4&scoped=true&lang=css";
      
      

var options = {};

options.styleTagTransform = styleTagTransformFn;
options.setAttributes = setAttributes;
options.insert = insertFn.bind(null, "head");
options.domAPI = domAPI;
options.insertStyleElement = insertStyleElement;

var update = API(content, options);



export * from "!!../../../eckpunkt-app/node_modules/css-loader/dist/cjs.js!../../../eckpunkt-app/node_modules/vue-loader/dist/stylePostLoader.js!../../../eckpunkt-app/node_modules/postcss-loader/dist/cjs.js!../../../eckpunkt-app/node_modules/vue-loader/dist/index.js??ruleSet[1].rules[9].use[0]!./ProductDetailsPage.vue?vue&type=style&index=0&id=080082d4&scoped=true&lang=css";
       export default content && content.locals ? content.locals : undefined;
